@if(isButton){
<button class="btn-tc btn-tertiary-new size-md" (click)="openVideo()" appMousePress [disableRipple]="true"
    mat-flat-button>
    <i class="ico-play-circle"></i>
    <div>{{'GENERAL.VIDEO_GUIDE' | translate}}</div>
</button>
} @else {
<span class="video-guide" (click)="openVideo()">
    <i class="fa-regular fa-circle-play"></i>
    <div>{{'GENERAL.VIDEO_GUIDE' | translate}}</div>
</span>
}